import { Node } from '@tiptap/core'


// custom extension for adding styled paragraphs
export const ColorBlock = Node.create({
    name: 'colorBlock',
    group: 'block',
    content: 'block+',
    draggable: false,
    defining: true,

    addOptions() {
        return {
            getTiptapBlockStylingString: () => 'padding: 16px; padding-bottom: 1px; border-radius: 4px;',
            getTiptapBlockStylingObject: (el) => {
                el.style.padding = '16px';
                el.style.paddingBottom = '1px';
                el.style.borderRadius = '4px';
                el.style.display = 'block';
                return el;
            }
        }
    },

    addAttributes() {
        return {
            color: {
                default: '#FFFF00',
                parseHTML: element => element.style.backgroundColor || '#FFFF00',
                renderHTML: attributes => {
                    return {
                        style: `background-color: ${attributes.color}; ${this.options.getTiptapBlockStylingString()}`
                    }
                },
            },
        }
    },

    parseHTML() {
      return [
        {
          tag: 'div[data-color-block]',
          getAttrs: element => {
            // Probeer eerst inline style te lezen
            const style = element.getAttribute('style') || ''
            const match = style.match(/background-color:\s*([^;]+)/i)
            const backgroundColor = match ? match[1].trim() : '#FFFF00'
    
            return {
              color: backgroundColor,
            }
          },
        },
      ]
    },

    renderHTML({ HTMLAttributes }) {
      const self = this;
      let backgroundColor = HTMLAttributes.style.match(/background-color:\s*([^;]+)/)[1]
      
      // Use this.options instead of options parameter
      const stylingString = self.options.getTiptapBlockStylingString ? self.options.getTiptapBlockStylingString() : 'padding: 16px; padding-bottom: 1px; border-radius: 4px;';
      
      return [
        'div',
        {
          'data-color-block': 'true',
          style: `background-color: ${backgroundColor || '#FFFF00'}; ${stylingString}`,
        },
        0, // content (je paragraph(s))
      ]
    },

    addNodeView() {
      const self = this;
      return ({ node }) => {
        const div = document.createElement('div')
        div.setAttribute('data-color-block', 'true')
        div.style.backgroundColor = node.attrs.color || '#FFFF00'
        
        // Use this.options instead of options parameter
        const stylingFunc = self.options.getTiptapBlockStylingObject || ((el) => {
          el.style.padding = '16px';
          el.style.paddingBottom = '1px';
          el.style.borderRadius = '4px';
          el.style.display = 'block';
          return el;
        });
        stylingFunc(div);
    
        // Maak een content container voor paragrafen
        const contentDOM = document.createElement('div')
        div.append(contentDOM)
    
        return {
          dom: div,
          contentDOM,
        }
      }
    },

  addCommands() {
    return {
      toggleColorBlock:
        attributes =>
        ({ commands, state, tr }) => {

          // Check if we're already inside a colorBlock
          const { $from } = state.selection
          const colorBlock = $from.node(-1)
          
          if (colorBlock && colorBlock.type.name === this.name) {
            // If we're already in a colorBlock, unwrap it
            return commands.lift(this.name)
          } else {
            // Otherwise, wrap in colorBlock
            return commands.wrapIn(this.name, attributes)
          }
        },
      setColorBlock:
        attributes =>
        ({ commands, state }) => {

          // Always wrap in colorBlock (for setting specific color)
          return commands.wrapIn(this.name, attributes)
        },
      removeColorBlock:
        () =>
        ({ commands }) => {
          return commands.lift(this.name)
        },
    }
  },
})